
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/chatbot",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/chatbot.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/chatbot"])
      });
    }
  